import { Injectable } from '@angular/core';
import { CanLoad, Route, UrlSegment } from '@angular/router';
import { UserService } from '@app/services/user.service'
import { Router } from '@angular/router';
import { path_module_employer, path_module_public } from '@app/models/routes.name';
import { profile_access_module } from '@app/config/role-name.enum';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModuleActivateGuard implements CanLoad {
  module: profile_access_module;
  subscription: Subscription;

  constructor(
    private userService: UserService,
    private router: Router
  ) {

    this.subscription = this.userService.moduleActivateBehavior.pipe().subscribe(value => {
      if (value !== null && this.module) {
        this.canLoad(null, null);
      }
    })
  }

  async canLoad(route: Route, segments: UrlSegment[]): Promise<boolean> {

    this.module = route?.data?.['module'] || this.module;

    await this.userService.loadPermissions();

    const activate = this.module && this.userService.hasActivateModule(this.module);
    const access = this.module && this.userService.hasAccessToModule(this.module);

    if (activate && access) {
      return true;
    }

    // this.unsuscribeRoleBehavior();

    this.unsuscribeActivateBehavior();

    if (!this.userService.loggedIn()) {
      this.router.navigate([path_module_employer.module, path_module_employer.login], { queryParams: { returnUrl: window.location.pathname } });
    }
    else {
      this.router.navigate([path_module_public.forbbiden]);
    }


    return false;
  }

  ngOnDestroy() {
    this.unsuscribeActivateBehavior();
  }

  unsuscribeActivateBehavior() {
    if (this, this.subscription) { this.subscription.unsubscribe(); }
  }
}
